import React from "react"
import { createIcon } from "@chakra-ui/react"

export const Etherscan = createIcon({
  displayName: "Etherscan",
  viewBox: "0 0 293.775 293.67",
  path: (
    <g transform="translate(-219.378 -213.33)">
      <path
        d="m280.433 353.152a12.45 12.45 0 0 1 12.508-12.452l20.737.068a12.467 12.467 0 0 1 12.467 12.467v78.414c2.336-.692 5.332-1.43 8.614-2.2a10.389 10.389 0 0 0 8.009-10.11v-97.266a12.469 12.469 0 0 1 12.468-12.47h20.778a12.469 12.469 0 0 1 12.467 12.467v90.279s5.2-2.106 10.269-4.245a10.408 10.408 0 0 0 6.353-9.577v-107.627a12.466 12.466 0 0 1 12.466-12.467h20.778a12.468 12.468 0 0 1 12.468 12.467v88.625c18.014-13.055 36.271-28.758 50.759-47.639a20.926 20.926 0 0 0 3.185-19.537 146.6 146.6 0 0 0 -136.644-99.006c-81.439-1.094-148.744 65.385-148.736 146.834a146.371 146.371 0 0 0 19.5 73.45 18.56 18.56 0 0 0 17.707 9.173c3.931-.346 8.825-.835 14.643-1.518a10.383 10.383 0 0 0 9.209-10.306v-77.824"
        fill="currentColor"
      />
      <path
        d="m244.417 398.641a146.808 146.808 0 0 0 233.172-118.741c0-3.381-.157-6.724-.383-10.049-53.642 80-152.686 117.4-232.79 128.793"
        fill="currentColor"
        transform="translate(35.564 80.269)"
      />
    </g>
  ),
})
